import React, { useEffect, useState } from "react";
import DashboardAdmin from "./DashboardAdmin";
import { getUserData } from "../utils/localStorage";
import NODashboard from "./NODashboard";
import DashboardTeleCaller from "./DashboardTeleCaller";
import DashboardEmployee from "./DashboardEmployee";
import DashboardOperation from "./DashboardOperation";
import DashboardSuperTeleCaller from "./DashboardSuperTeleCaller";
import DashboardBusinessPartnerHandler from "./DashboardBusinessPartnerHandler";
import BusinessPartnerList from "./UserMaster/BusinessPartner/BusinessPartnerList";
import DashboardBranchManager from "./DashboardBranchManager";
import DashboardBusinessPartner from "./DashboardBusinessPartner";
import AccountantLeadList from "./Leads/AccountantLeadList";

const Dashboard = () => {
    
  const { userProfileData } = getUserData();

  return (
    <div>
      {userProfileData?.role === "ROLE_TELECALLER" ? (
        <DashboardTeleCaller />
      ) : userProfileData?.role === "ROLE_EMPLOYEE" ? (
        <DashboardEmployee />
      ) : userProfileData?.role === "ROLE_OPERATION" ? (
        <DashboardOperation />
      ) : userProfileData?.role === "ROLE_SUPER_TELECALLER" ? (
        <DashboardSuperTeleCaller />
      ) : userProfileData?.role === "ROLE_BUSINESS_PARTNER_HANDLER" ? (
        <BusinessPartnerList />
      ) : userProfileData?.role === "ROLE_BRANCH_MANAGER" ? (
        <DashboardBranchManager />
      ) : userProfileData?.role === "ROLE_BUSINESS_PARTNER" ? (
        <DashboardBusinessPartner />
      ) : userProfileData?.role === "ROLE_ACCOUNTANT" ? (
                      <AccountantLeadList />  
      ) : userProfileData?.role === "ROLE_ADMIN" ? (
        <DashboardAdmin />
      ) : (
        <NODashboard />
      )}
    </div>
  );
};

export default Dashboard;
